import React, { useState } from 'react';
import axios from 'axios';

const DELETE_ACCOUNT_BASE = 'https://api.svastiq.com/api/deleteaccount';

const DeleteAccountComponent = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' }); // type: 'success' | 'error'

    const sendOtp = async () => {
        const trimmed = phoneNumber.trim();
        if (!trimmed) {
            setMessage({ text: 'Please enter your phone number.', type: 'error' });
            return;
        }
        setMessage({ text: '', type: '' });
        setLoading(true);
        try {
            const response = await axios.get(`${DELETE_ACCOUNT_BASE}/${encodeURIComponent(trimmed)}`);
            setOtpSent(true);
            setMessage({
                text: response.data?.message || 'OTP sent to your phone. Please enter it below.',
                type: 'success',
            });
        } catch (err) {
            const msg =
                err.response?.data?.message ||
                err.response?.data?.error ||
                err.message ||
                'Failed to send OTP. Please try again.';
            setMessage({ text: msg, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const deleteAccount = async () => {
        const trimmedPhone = phoneNumber.trim();
        const trimmedOtp = otp.trim();
        if (!trimmedPhone || !trimmedOtp) {
            setMessage({ text: 'Please enter both phone number and OTP.', type: 'error' });
            return;
        }
        setMessage({ text: '', type: '' });
        setLoading(true);
        try {
            const response = await axios.get(
                `${DELETE_ACCOUNT_BASE}/${encodeURIComponent(trimmedPhone)}/${encodeURIComponent(trimmedOtp)}`
            );
            const responseMsg = response.data?.message || response.data?.error || '';
            const isInvalidOtpOrNotFound =
                typeof responseMsg === 'string' && responseMsg.toLowerCase().includes('invalid otp or customer not found');
            if (isInvalidOtpOrNotFound) {
                setMessage({ text: 'Invalid OTP.', type: 'error' });
            } else {
                setMessage({
                    text: responseMsg || 'Your account has been deleted successfully.',
                    type: 'success',
                });
                setOtp('');
            }
        } catch (err) {
            if (err.response?.status === 400) {
                setMessage({ text: 'Invalid OTP.', type: 'error' });
                return;
            }
            const rawMsg =
                err.response?.data?.message ||
                err.response?.data?.error ||
                err.message ||
                '';
            const isInvalidOtpOrNotFound =
                typeof rawMsg === 'string' && rawMsg.toLowerCase().includes('invalid otp or customer not found');
            const msg = isInvalidOtpOrNotFound ? 'Invalid OTP.' : (rawMsg || 'Failed to delete account. Please check the OTP and try again.');
            setMessage({ text: msg, type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="d-flex align-items-center justify-content-center vh-100">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                    <div className="card mb-3 w-100">
                        <div className="card-body">
                            <div className="pt-4 pb-2">
                                <h5 className="card-title text-center pb-0 fs-4">Delete Account</h5>
                                <p className="text-center small">Enter your phone number to request account deletion</p>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                                    <input
                                        type="tel"
                                        id="phoneNumber"
                                        className="form-control"
                                        placeholder="e.g. 9876543210"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        disabled={otpSent}
                                    />
                                </div>

                                {!otpSent ? (
                                    <div className="col-12">
                                        <button
                                            className="btn btn-primary w-100"
                                            type="button"
                                            onClick={sendOtp}
                                            disabled={loading}
                                        >
                                            {loading ? 'Sending...' : 'Send OTP'}
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <div className="col-12">
                                            <label htmlFor="otp" className="form-label">Enter OTP</label>
                                            <input
                                                type="text"
                                                id="otp"
                                                className="form-control"
                                                placeholder="Enter OTP received"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                maxLength={6}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <button
                                                className="btn btn-danger w-100"
                                                type="button"
                                                onClick={deleteAccount}
                                                disabled={loading}
                                            >
                                                {loading ? 'Deleting...' : 'Delete Account'}
                                            </button>
                                        </div>
                                        <div className="col-12">
                                            <button
                                                className="btn btn-outline-secondary w-100"
                                                type="button"
                                                onClick={() => {
                                                    setOtpSent(false);
                                                    setOtp('');
                                                    setMessage({ text: '', type: '' });
                                                }}
                                                disabled={loading}
                                            >
                                                Change Phone Number
                                            </button>
                                        </div>
                                    </>
                                )}

                                {message.text && (
                                    <div className="col-12">
                                        <div
                                            className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`}
                                            role="alert"
                                        >
                                            {message.text}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteAccountComponent;
